import React from 'react';
import { motion } from 'framer-motion';
import { bundles } from '../data/mockData';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheck, FiArrowRight } = FiIcons;

export default function Bundles() {
  return (
    <section id="bundles" className="py-32 bg-zinc-900 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <span className="text-red-500 font-bold uppercase tracking-[0.3em] text-xs mb-4 block">Ultimate Value</span>
          <h2 className="text-4xl md:text-6xl font-black text-white tracking-tighter mb-6">THE CHEF'S CABINET</h2>
          <p className="text-zinc-400 max-w-2xl mx-auto text-lg leading-relaxed">
            Engineered workflows in a box. Our bundles are curated to provide everything you need for specific culinary tasks at a significant discount.
          </p>
        </div>

        <div className="space-y-12">
          {bundles.map((bundle, index) => (
            <motion.div
              key={bundle.id}
              initial={{ opacity: 0, x: index % 2 === 0 ? -40 : 40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} bg-zinc-800/50 border border-zinc-700/50`}
            >
              <div className="lg:w-1/2 relative overflow-hidden h-[400px] lg:h-auto">
                <img 
                  src={bundle.image} 
                  alt={bundle.name}
                  className="w-full h-full object-cover transition-transform duration-1000 hover:scale-105"
                />
                <div className="absolute top-0 left-0 bg-red-600 text-white font-black px-6 py-3 uppercase tracking-widest text-xs">
                  Save ${bundle.originalPrice - bundle.price}
                </div>
              </div>
              <div className="lg:w-1/2 p-10 lg:p-16 flex flex-col justify-center">
                <h3 className="text-3xl md:text-4xl font-black text-white mb-6 tracking-tighter uppercase">{bundle.name}</h3>
                <p className="text-zinc-400 mb-8 text-lg leading-relaxed">{bundle.description}</p>
                
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
                  {bundle.includes.map((item, i) => (
                    <div key={i} className="flex items-center gap-3 text-zinc-300">
                      <div className="w-6 h-6 rounded-full bg-red-600/20 flex items-center justify-center shrink-0">
                        <SafeIcon icon={FiCheck} className="text-red-500 text-xs" />
                      </div>
                      <span className="text-sm font-medium tracking-wide uppercase">{item}</span>
                    </div>
                  ))}
                </div>

                <div className="flex flex-wrap items-center gap-8 border-t border-zinc-700/50 pt-10">
                  <div className="flex flex-col">
                    <span className="text-4xl font-black text-white tracking-tighter">${bundle.price}</span>
                    <span className="text-zinc-500 line-through text-sm font-bold uppercase tracking-widest">${bundle.originalPrice}</span>
                  </div>
                  <button className="btn-primary flex-1 sm:flex-none py-5 px-10 group">
                    ADD TO WORKSPACE
                    <SafeIcon icon={FiArrowRight} className="group-hover:translate-x-1 transition-transform" />
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}